<script>
  const commonInputProps = {
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: Object,
      default: () => null
    },
    outsetIcon: Boolean,
    tabIndex: {
      type: Number,
      default: 0
    },
    error: Boolean,
    success: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    large: Boolean,
    small: Boolean,
    emitInputOnChange: {
      type: Boolean,
      default: true
    }
  };

  export default {
    name: 'InputMixin',
    props: commonInputProps,
    computed: {
      commonInputProps () {

        // return object with all props in mixin to use with v-bind
        const props = {};
        for (const key of Object.keys(commonInputProps)) {
          props[key] = this[key];
        }
        return props;
      }
    },
    created () {
      if (this.error && this.success) {
        throw new Error('Can not set both `error` and `success` props');
      }
    }
  };
</script>
